// Setup everything needed (Globals - 3rd party or otherwise to get the app ready to initialize)
import './bootstrap';
import {getPrefixedLogger} from '@netx/core-next/instance/logger';

const logger = getPrefixedLogger('init');

// After i18n (success or fail) and custom css properties we will load the app
function loadApp() {
	// Initialize core
	import(/* webpackChunkName: "@netx/core" */ '@netx/core').then((Core) => {
		Core.default.initialize();
	});
}

import {initializeI18n} from '@netx/core-next/locales';
import css from './css';

logger.debug('initializing css and i18n');

// DAM-15140
// We cannot use Promise.finally due to iOS safari
// changing the babel config to handle this issue
// causes some weird things with plupload - not worth
// fighting at the moment - so, jQuery.Deferred it is
$.when(
	// Load custom CSS before loading in core
	css(),
	// Load i18n and base locales before loading in core
	initializeI18n(),
)
	.then(
		() => {},
		(err) => {
			logger.error('failed to initialize css or i18n', err.message);
		},
	)
	.always(() => {
		logger.debug('initialized');
		loadApp();
	});
